import React from 'react';
import { useFetchWithStatusV2 } from 'hooks/fetchWithStatus';
import { SECONDARY_API_CLIENT } from 'services/API';
import { When } from 'UI/components/atoms/When';
import { ProfileAlert } from 'UI/components/molecules/ProfileAlert';
import { Endpoints } from 'UI/constants/endpoints';
import { UIStatus } from 'UI/constants/status';

export const CompanyPaymentStatusAlert = ({ companyId, isLoading = false }) => {
  const { state: paymentStatusState } = useFetchWithStatusV2({
    endpoint: companyId ? Endpoints.CompanyPaymentStatus.replace(':id', String(companyId)) : null,
    apiInstance: SECONDARY_API_CLIENT
  });

  const isPaymentStatusLoading = paymentStatusState?.status === UIStatus.Loading;
  const paymentStatus = paymentStatusState?.results;

  return (
    <When
      condition={
        !isLoading && !isPaymentStatusLoading && paymentStatus && paymentStatus?.hasWarning
      }
    >
      <ProfileAlert
        primaryText={paymentStatus?.warning?.content}
        severity="error"
        title={paymentStatus?.warning?.title}
      />
    </When>
  );
};
